/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileWord16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.25 14a.748.748 0 00.75-.75V2.75a.748.748 0 00-.75-.75H5a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 002 5v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 005 14h8.25zm0-9.75H5v-1.5h8.25v1.5zm0 3H9.5V5h3.75v2.25zm-8.104 3.188h-1.26L2.804 5.561H4.01l.55 2.801.61-2.8h1.184l.638 2.783.51-2.784h1.195L7.62 10.438H6.377l-.633-2.8-.598 2.8zm8.104-.188H9.5V8h3.75v2.25zm0 3H5v-1.5h3.75A.748.748 0 009.5 11h3.75v2.25z"
        />
    </AccessibleSVG>
);

export default FileWord16;
